import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
import "./progress-dialog.scss";
import { Cancel } from "@material-ui/icons";
import { ReactElement, useEffect, useState } from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import { IProgressDialogProps } from "./props";

/** It indicates the status of a progress */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function ProgressDialog(props: IProgressDialogProps)
{
    const [errorMsg, setErrorMsg] = useState<string | undefined>(props.errorText);
    const [errorCategoryMsg, setErrorCategoryMessage] = useState<string | undefined>(props.errorCategoryText);

    useEffect(() =>
    {
        setErrorMsg(props.errorText);
    }, [props.errorText]);

    useEffect(() =>
    {
        setErrorCategoryMessage(props.errorCategoryText);
    }, [props.errorCategoryText]);

    const renderDialogContent = (text: string, errorText: string | undefined) => (
        errorText
            ? undefined
            : <DialogContent>{renderCircularProgress(errorText)}{renderDialogContentText(text, errorText)}</DialogContent>);

    const renderDialogActions = (
        onCancelButtonClick: () => void,
        onRetryButtonClick: () => void,
        retryButtonIcon: ReactElement<any, any>,
        retryButtonText: string,
        errorText: string | undefined
    ) => (
        errorText
            ? (
                <DialogActions>
                    <Button
                        startIcon={<Cancel />}
                        variant="contained"
                        color="secondary"
                        onClick={onCancelButtonClick}
                    >
                        Mégsem
                    </Button>
                    <Button
                        startIcon={retryButtonIcon}
                        variant="contained"
                        color="primary"
                        onClick={onRetryButtonClick}
                        autoFocus
                    >
                        {retryButtonText}
                    </Button>
                </DialogActions>
            )
            : undefined
    );

    const renderAlert = (errorText: string | undefined, errorCategoryText: string | undefined) => (
        errorText
            ? (
                <Alert className="process-dialog-alert" severity="error">{errorCategoryText
                    ? <AlertTitle>{errorCategoryText}</AlertTitle> : undefined}{errorText}
                </Alert>)
            : undefined
    );

    const renderCircularProgress = (errorText: string | undefined) => (
        errorText
            ? undefined
            : <div className="circular-progress-container"><CircularProgress /></div>
    );

    const renderDialogContentText = (text: string, errorText: string | undefined) => (
        errorText
            ? undefined
            : <DialogContentText>{text}</DialogContentText>
    );

    return (
        <Dialog open={props.open || false}>
            {renderAlert(errorMsg, errorCategoryMsg)}
            {renderDialogContent(props.text, errorMsg)}
            {renderDialogActions(
                props.onCancelButtonClick,
                props.onRetryButtonClick,
                props.retryButtonIcon,
                props.retryButtonText,
                errorMsg)}
        </Dialog>
    );
}


